import type { BusinessUnitStore } from '../../../../stores/business-unit';
import {
    SELECT_ALL_VALUE,
    useConstructBusinessUnitTreeData,
} from '../../shared/hooks/use-construct-business-unit-tree-data';

interface Props {
    businessUnitStore: BusinessUnitStore;
}

const getProvinceCode = (provinceName: string) => provinceName.toUpperCase();

export const useConstructTreeDataByCode = ({ businessUnitStore }: Props) => {
    const {
        treeData,
        allProvinceValues: allProvinceCodes,
        businessUnitToProvincesMap,
    } = useConstructBusinessUnitTreeData({
        businessUnitStore,
        getProvinceValue: (province) => getProvinceCode(province.name),
    });

    return {
        treeData,
        allProvinceCodes,
        businessUnitToProvincesMap,
    };
};

export { SELECT_ALL_VALUE };
